
import React from 'react'

/* eslint-disable no-unused-vars */
// import ggle from "./images/google.svg";
// import apl from "./images/apple.svg";
// import fb from "./images/fb.svg";
import "./Footer.css";


const Footer = () => {
    return (
        <div className="foot">
            {/* <div className='dvdr'>
            <span className='line'></span>
            <span className='alt'>or sign up with</span>
            <span className='line'></span>
        </div>
        <div className='socials'>
            <img src={ggle} className="social" alt="social"/>
            <img src={apl} className="social" alt="social"/>
            <img src={fb} className="social" alt="social"/> 
        </div> */}
        </div>
    );
};

export default Footer;
